var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlikedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59449 2.32283L6.00073 2.88898L6.40697 2.32283C6.91477 1.61514 7.73975 1.155 8.6734 1.155C10.2136 1.155 11.4624 2.40377 11.4624 3.94433C11.4624 4.15943 11.4352 4.37016 11.3864 4.57692L11.3823 4.5945L11.3794 4.61233C11.1734 5.89393 10.3421 7.26386 9.2487 8.43227C8.2164 9.53535 7.00581 10.3996 6.00071 10.8089C4.99548 10.3996 3.7849 9.53536 2.75255 8.43223C1.65909 7.26379 0.827665 5.89373 0.621378 4.61189L0.618621 4.59476L0.614685 4.57787C0.566299 4.37021 0.539062 4.15909 0.539062 3.94433C0.539062 2.40351 1.78784 1.155 3.3284 1.155C4.26168 1.155 5.08667 1.61511 5.59449 2.32283Z",
    stroke: "#B43B8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlikedIcon);
export default __webpack_public_path__ + "static/media/unliked-icon.b2f6334274ae5fe5e66e4380d62d1445.svg";
export { ForwardRef as ReactComponent };